import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { useAppSelector } from "@/hooks/use-state";
import { selectMenu } from "@/features/auth/authSlice";
import { buildMenuTree } from "@/components/utils/menu-builder";
import { Badge } from "@/components/ui/badge";
import { useLocation } from "wouter";
import { LogOut, Settings, User } from "lucide-react";
import { GrupoUsuarioData, UserAuth } from "@/features/auth/auth.interface";

export interface SidebarMenuMobileProps {
  user: UserAuth | null;
  userGroup: GrupoUsuarioData | null;
  handleLogout: () => void;
  onNavigate: () => void;
}


export function SidebarMenuMobile({ user, userGroup, handleLogout, onNavigate }: SidebarMenuMobileProps) {
  const menu = useAppSelector(selectMenu);
  const menuTree = buildMenuTree(menu);
  const [, navigate] = useLocation();

  const onClickItem = (path: string) => {
    navigate(path);
    onNavigate();
  };

  const goToMyAccount = () => {
    navigate("/my-account");
  }

  return (
    <div className="flex flex-col h-full text-white overflow-y-auto">

      {/* SECCIÓN DE MENÚ */}
      <Accordion type="single" collapsible className="px-4 mt-4 space-y-2">

        {menuTree.map(level1 => (
          <AccordionItem key={level1.id} value={`l1-${level1.id}`}>
            <AccordionTrigger className="text-sm text-white font-bold flex items-center justify-start text-left gap-2">
              {level1.icon && <i className={level1.icon}></i>} {level1.nombre}
            </AccordionTrigger>

            <AccordionContent>
              {level1.children.map(level2 => (
                <Accordion key={level2.id} type="single" collapsible className="ml-2">

                  <AccordionItem value={`l2-${level2.id}`}>
                    <AccordionTrigger className="text-xs text-gray-300 ml-2">
                      {level2.nombre}
                    </AccordionTrigger>

                    <AccordionContent>
                      <div className="ml-4 space-y-2">
                        {level2.children.map(level3 => (
                          <button
                            key={level3.id}
                            onClick={() => onClickItem(level3.path)}
                            className="block w-full text-left text-xs font-semibold border-2 border-blue-200 bg-gray-100 text-[var(--color-secondary)] py-2 px-2 rounded hover:bg-[var(--color-secondary)] hover:text-white"
                          >
                            {level3.nombre}
                          </button>
                        ))}
                      </div>
                    </AccordionContent>
                  </AccordionItem>

                </Accordion>
              ))}
            </AccordionContent>
          </AccordionItem>
        ))}

      </Accordion>

      {/* SECCIÓN USUARIO */}
      <div className="mt-auto bg-[#1E293B] p-4 border-t border-gray-700">
        <div className="flex items-center gap-3">
          <User size={24} />
          <div className="text-center flex flex-col items-center justify-center">
            <p className="font-medium text-xs mb-1">{user?.name ?? '' + ' Apellido'}</p>
            <div className="text-xs text-gray-300 text-center">
              <Badge>{userGroup?.nombre ?? "Sin Rol"}</Badge>
            </div>
          </div>
        </div>
        <button
          onClick={goToMyAccount}
          className="w-full mt-3 flex items-center py-2 px-2 rounded-lg gap-2 border-2 border-blue-200 bg-gray-200 text-[var(--color-secondary)]"
        >
          <Settings size={16} className="mr-2" /> Mi Cuenta
        </button>

        <button
          onClick={handleLogout}
          className="w-full mt-3 flex items-center py-2 px-2 rounded-lg gap-2 bg-red-500 text-red-100"
        >
          <LogOut size={16} /> Cerrar sesión
        </button>
      </div>

    </div>
  );
}